import { gql } from '@apollo/client';

export const RdProjectTeamMemberFragment = gql`
  fragment RdProjectTeamMember on RdProjectTeamMember {
    rdTaxCreditContributorId
    contributorName
    contributorEmail
    allocationPercent
    rdProjectId
    rdExpenseId
    fiscalYearId
  }
`;
